import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetModerationVacancy = {
  getModerationVacancy: { data: null, loading: false, error: null },
};

export const getModerationVacancy = createAsyncThunk('user/getModerationVacancy', async (id, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/vacancies/${id}/moderation`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetModerationVacancy = {
  [getModerationVacancy.pending]: (state) => {
    state.getModerationVacancy.loading = true;
    state.getModerationVacancy.error = null;
  },
  [getModerationVacancy.fulfilled]: (state, action) => {
    state.getModerationVacancy.loading = false;
    state.getModerationVacancy.data = action.payload;
    state.getModerationVacancy.error = null;
  },
  [getModerationVacancy.rejected]: (state, action) => {
    state.getModerationVacancy.loading = false;
    state.getModerationVacancy.error = true;
  },
};
